export const ROUTE_TITLE_COURSE_NAME_TOKEN = "$course";
export const ROUTE_TITLE_EVENT_NAME_TOKEN = "$event";
export const ROUTE_TITLE_NODE_NAME_TOKEN = "$node";
